import React from 'react'

const Hamburger = props => (
  <svg viewBox="0 0 65.65 43.82" {...props}>
    <path
      d="M61.65 0H4a4 4 0 0 0 0 8h57.65a4 4 0 1 0 0-8z"
      fill={props.color ? props.color : '#fff'}
    />
    <path
      d="M61.65 17.91H4a4 4 0 0 0 0 8h57.65a4 4 0 1 0 0-8z"
      fill={props.color ? props.color : '#fff'}
    />
    <path
      d="M61.65 35.82H4a4 4 0 0 0 0 8h57.65a4 4 0 1 0 0-8z"
      fill={props.color ? props.color : '#fff'}
    />
  </svg>
)

export default Hamburger



// WEBPACK FOOTER //
// ./src/components/shared/hamburger.js